var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusdotGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.370239,
    width: 16,
    height: 16,
    rx: 4.2517,
    fill: "#DDFFEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.42297,
    cy: 8,
    r: 4,
    fill: "#13B75B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusdotGreen);
export default __webpack_public_path__ + "static/media/statusdot-green.59b4a91ec8a4d175d6af89faee397c2f.svg";
export { ForwardRef as ReactComponent };